import {z} from "zod";

export const DIRECTIONAL_LIGHT_MODES = ["DARKNESS", "DAYLIGHT", "MOONLIGHT"] as const;
export const DIRECTIONAL_LIGHT_LABELS = {DARKNESS: "Dunkelheit", DAYLIGHT: "Tageslicht", MOONLIGHT: "Mondschein"};
export const directionalLightSchema = z.object({
    mode: z.enum(DIRECTIONAL_LIGHT_MODES),
    directionDegrees: z.number().min(0).lt(360),
    intensity: z.number().min(0).max(1),
    colorStrength: z.number().min(0).max(1),
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
});
export type DirectionalLight = z.infer<typeof directionalLightSchema>;
/** Direction FROM which light arrives: 0=north, 90=east, 180=south, 270=west. */
export function directionalLightPreset(mode: DirectionalLight["mode"], directionDegrees = 0): DirectionalLight {
    const values = mode === "DAYLIGHT" ? {intensity: 1, colorStrength: 0.25, color: "#fff2d1"}
        : mode === "MOONLIGHT" ? {intensity: 0.5, colorStrength: 0.55, color: "#8dafff"}
        : {intensity: 0, colorStrength: 0, color: "#ffffff"};
    return {mode, directionDegrees, ...values};
}
export const createDirectionalLight = (): DirectionalLight => directionalLightPreset("DARKNESS");
